import type { IdentifierModel, IdentifierValueModel, UUID } from "@overmap-ai/common"

import { createFilterDefConfig } from "../../schemas"
import { IdentifierFilterDef } from "../IdentifierFilterDef"

export const getFilterDefOfIdentifier = <TIdentifier extends UUID<IdentifierModel>, TData>(
	identifier: TIdentifier,
	getValues: (identifier: TIdentifier) => (data: TData) => IdentifierValueModel["value"] | null,
) => {
	return createFilterDefConfig({
		filterDef: new IdentifierFilterDef(identifier),
		accessorFn: getValues(identifier),
	})
}

export const getFilterDefsOfIdentifiers = <TIdentifier extends UUID<IdentifierModel>, TData>(
	identifiers: TIdentifier[],
	getValues: (identifier: TIdentifier) => (data: TData) => IdentifierValueModel["value"] | null,
) => {
	return identifiers.map((identifier) => {
		return getFilterDefOfIdentifier(identifier, getValues)
	})
}
